
import { Author, Publication, Metric, Video, HeroSlide, NewsItem, Activity, Partner, ProgramItem } from './types';

// Warna rujukan Digdaya NU: Deep Emerald Green & Gold

export const AUTHORS: Author[] = [
  {
    id: '1',
    name: 'Dr. KH. Ulil Abshar Abdalla',
    role: 'Ketua Lakpesdam PBNU',
    imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?fit=crop&w=400&h=400',
    profileLink: '#',
  },
  {
    id: '2',
    name: 'Hj. Alissa Wahid',
    role: 'Dewan Pengarah',
    imageUrl: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?fit=crop&w=400&h=400',
    profileLink: '#',
  },
  {
    id: '3',
    name: 'Prof. Dr. Nadirsyah Hosen',
    role: 'Peneliti Senior',
    imageUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?fit=crop&w=400&h=400',
    profileLink: '#',
  },
  {
    id: '4',
    name: 'Marzuki Wahid',
    role: 'Sekretaris',
    imageUrl: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?fit=crop&w=400&h=400',
    profileLink: '#',
  },
];

export const HERO_SLIDES: HeroSlide[] = [
  {
    id: 'slide-1',
    title: 'Muktamar Pemikiran NU: Imamah dan Keadilan Sosial',
    subtitle: 'Meneguhkan kembali peran strategis Nahdlatul Ulama dalam membangun peradaban dunia yang berkeadilan.',
    category: 'Muktamar Pemikiran',
    imageUrl: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=2070',
  },
  {
    id: 'slide-2',
    title: 'Peta Jalan Kemandirian Ekonomi Pesantren',
    subtitle: 'Strategi adaptasi ekonomi pesantren pasca-pandemi dan integrasi teknologi digital.',
    category: 'Riset Ekonomi',
    imageUrl: 'https://images.unsplash.com/photo-1526666923127-b2970f64b422?q=80&w=2072',
  },
  {
    id: 'slide-3',
    title: 'Halaqah Fikih Peradaban',
    subtitle: 'Rangkaian diskusi panjang mengenai respon hukum Islam terhadap tantangan geopolitik global.',
    category: 'Kajian Strategis',
    imageUrl: 'https://images.unsplash.com/photo-1529070538774-1843cb3265df?q=80&w=2070',
  },
];

export const LATEST_NEWS: NewsItem[] = [
  {
    id: 'n1',
    title: 'Lakpesdam PBNU Gelar Pelatihan Metodologi Riset untuk Kader Muda',
    date: '12 November 2023',
    category: 'Kaderisasi',
    imageUrl: 'https://images.unsplash.com/photo-1544531586-fde5298cdd40?w=600',
    excerpt: 'Upaya meningkatkan kapasitas intelektual kader dalam melakukan pembacaan sosial yang tajam dan akurat.'
  },
  {
    id: 'n2',
    title: 'Kerjasama Strategis: Penguatan Desa Inklusif',
    date: '08 November 2023',
    category: 'Program',
    imageUrl: 'https://images.unsplash.com/photo-1596496050844-4610e745434c?w=600',
    excerpt: 'Program pendampingan masyarakat desa untuk menciptakan lingkungan yang ramah bagi kelompok rentan.'
  },
  {
    id: 'n3',
    title: 'Opini: Menjaga Nalar Publik di Tahun Politik',
    date: '01 November 2023',
    category: 'Opini',
    imageUrl: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=600',
    excerpt: 'Peran organisasi masyarakat sipil dalam menjaga kejernihan berpikir di tengah polarisasi politik.'
  }
];

export const BRANCH_UPDATES: NewsItem[] = [
  {
    id: 'b1',
    title: 'PCNU Cilacap Luncurkan Program Sekolah Ekologi',
    date: '14 November 2023',
    category: 'Jawa Tengah',
    imageUrl: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=600',
    excerpt: 'Inisiatif hijau untuk melestarikan lingkungan pesisir melalui pendidikan berbasis komunitas.'
  },
  {
    id: 'b2',
    title: 'Pelatihan Paralegal untuk Warga Desa di Malang',
    date: '10 November 2023',
    category: 'Jawa Timur',
    imageUrl: 'https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?w=600',
    excerpt: 'Meningkatkan kesadaran hukum masyarakat desa dalam menghadapi sengketa agraria.'
  },
  {
    id: 'b3',
    title: 'Lakpesdam Lampung Gelar Diskusi Moderasi Beragama',
    date: '05 November 2023',
    category: 'Lampung',
    imageUrl: 'https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=600',
    excerpt: 'Merajut kerukunan antar umat beragama di wilayah Sumatera bagian selatan.'
  }
];

export const UPCOMING_ACTIVITIES: Activity[] = [
  {
    id: 'a1',
    title: 'Diskusi Publik: RUU Masyarakat Adat',
    date: '20 Nov 2023',
    location: 'Gedung PBNU Lt. 8',
    type: 'Diskusi'
  },
  {
    id: 'a2',
    title: 'Workshop Penulisan Policy Brief',
    date: '25-26 Nov 2023',
    location: 'Hotel Acacia, Jakarta',
    type: 'Pelatihan'
  },
  {
    id: 'a3',
    title: 'Bedah Buku: Islam Nusantara',
    date: '01 Des 2023',
    location: 'Daring (Zoom)',
    type: 'Webinar'
  },
  {
    id: 'a4',
    title: 'Rapat Koordinasi Wilayah Jawa',
    date: '05 Des 2023',
    location: 'Semarang, Jawa Tengah',
    type: 'Rapat'
  }
];

export const IMPACT_METRICS: Metric[] = [
  { id: '1', label: 'Program Kelolaan', value: 4, suffix: '+' },
  { id: '2', label: 'Cabang & Wilayah', value: 248, suffix: '' },
  { id: '3', label: 'Keterlibatan Masyarakat', value: 28.847, suffix: '+' },
];

export const LATEST_VIDEOS: Video[] = [
  {
    id: '1',
    title: 'Halaqah Fikih Peradaban: Refleksi Satu Abad NU',
    thumbnailUrl: 'https://images.unsplash.com/photo-1560523160-754a9e25c68f?w=600',
    url: '#',
    duration: '1:20:15',
  },
  {
    id: '2',
    title: 'Dialog Kebangsaan: Menjaga NKRI dari Radikalisme',
    thumbnailUrl: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=600',
    url: '#',
    duration: '45:30',
  },
  {
    id: '3',
    title: 'Webinar: Ekonomi Pesantren di Era Digital',
    thumbnailUrl: 'https://images.unsplash.com/photo-1531403009284-440f080d1e12?w=600',
    url: '#',
    duration: '58:10',
  },
];

export const PUBLICATIONS: Publication[] = [
  {
    id: 'hero-1',
    slug: 'peta-jalan-kemandirian-ekonomi-umat',
    title: 'Peta Jalan Kemandirian Ekonomi Umat: Studi Kasus 50 Pesantren',
    excerpt: 'Sebuah analisis mendalam mengenai strategi adaptasi ekonomi pesantren pasca-pandemi.',
    author: AUTHORS[3],
    date: '10 Oktober 2023',
    year: 2023,
    category: 'Ekonomi Umat',
    type: 'Laporan Riset',
    imageUrl: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600',
  },
  {
    id: 'p2',
    slug: 'fikih-lingkungan-respon-pesantren-terhadap-perubahan-iklim',
    title: 'Fikih Lingkungan: Respon Pesantren Terhadap Perubahan Iklim',
    excerpt: 'Tinjauan hukum Islam dan praktik nyata komunitas pesantren dalam menjaga kelestarian lingkungan hidup.',
    author: AUTHORS[0],
    date: '15 September 2023',
    year: 2023,
    category: 'Lingkungan',
    type: 'Buku',
    imageUrl: 'https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=600',
  },
  {
    id: 'p3',
    slug: 'policy-brief-perlindungan-pekerja-migran-sektor-domestik',
    title: 'Policy Brief: Perlindungan Pekerja Migran Sektor Domestik',
    excerpt: 'Rekomendasi kebijakan untuk pemerintah terkait peningkatan perlindungan hukum bagi PMI.',
    author: AUTHORS[1],
    date: '02 Agustus 2023',
    year: 2023,
    category: 'Hak Asasi Manusia',
    type: 'Policy Brief',
    imageUrl: 'https://images.unsplash.com/photo-1555848962-6e79363ec58f?w=600',
  },
  {
    id: 'p4',
    slug: 'jurnal-tasawuf-dan-transformasi-sosial-vol-5',
    title: 'Jurnal Tasawuf dan Transformasi Sosial Vol. 5',
    excerpt: 'Kumpulan artikel ilmiah mengenai peran spiritualitas dalam gerakan sosial masyarakat sipil.',
    author: AUTHORS[2],
    date: '20 Juli 2022',
    year: 2022,
    category: 'Agama & Sosial',
    type: 'Jurnal',
  },
];

export const STAFF_MEMBERS: NewsItem[] = [
  {
    id: 'sm-1',
    title: 'Dr. KH. Ulil Abshar Abdalla',
    date: '2024-01-01',
    category: 'Staff',
    imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?fit=crop&w=400&h=400',
    excerpt: '',
    role: 'Ketua',
    responsibility: 'Ketua Lakpesdam PBNU',
    quote: 'Pemikiran kebangsaan harus terus digelorakan di tengah tantangan zaman.',
    order: 1
  },
  {
    id: 'sm-2',
    title: 'Hj. Alissa Wahid',
    date: '2024-01-01',
    category: 'Staff',
    imageUrl: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?fit=crop&w=400&h=400',
    excerpt: '',
    role: 'Wakil Ketua 1',
    responsibility: 'Dewan Pengarah',
    quote: 'Moderasi beragama adalah fondasi kehidupan berbangsa.',
    order: 2
  },
  {
    id: 'sm-3',
    title: 'Prof. Dr. Nadirsyah Hosen',
    date: '2024-01-01',
    category: 'Staff',
    imageUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?fit=crop&w=400&h=400',
    excerpt: '',
    role: 'Anggota',
    responsibility: 'Peneliti Senior',
    quote: '',
    order: 6
  },
  {
    id: 'sm-4',
    title: 'Marzuki Wahid',
    date: '2024-01-01',
    category: 'Staff',
    imageUrl: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?fit=crop&w=400&h=400',
    excerpt: '',
    role: 'Sekertaris',
    responsibility: 'Sekretaris',
    quote: '',
    order: 5
  }
];

export const PARTNERS: Partner[] = [
  {
    id: 'p1',
    name: 'Kementerian Agama RI',
    logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/Coat_of_arms_of_Ministry_of_Religious_Affairs_of_the_Republic_of_Indonesia.svg/100px-Coat_of_arms_of_Ministry_of_Religious_Affairs_of_the_Republic_of_Indonesia.svg.png',
    website: '#'
  },
  {
    id: 'p2',
    name: 'Bappenas',
    logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Logo_Bappenas_Indonesia.svg/100px-Logo_Bappenas_Indonesia.svg.png',
    website: '#'
  },
  {
    id: 'p3',
    name: 'The Asia Foundation',
    logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/The_Asia_Foundation_Logo.svg/150px-The_Asia_Foundation_Logo.svg.png',
    website: '#'
  },
  {
    id: 'p4',
    name: 'Kemendesa PDTT',
    logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Logo_of_the_Ministry_of_Villages%2C_Development_of_Disadvantaged_Regions%2C_and_Transmigration_of_the_Republic_of_Indonesia.svg/100px-Logo_of_the_Ministry_of_Villages%2C_Development_of_Disadvantaged_Regions%2C_and_Transmigration_of_the_Republic_of_Indonesia.svg.png',
    website: '#'
  },
  {
    id: 'p5',
    name: 'AIPJ',
    logoUrl: 'https://yt3.googleusercontent.com/ytc/AIdro_k6a6hK0y7D0n3t6w3Q5g5W6v6_4h6Z5x6J5c6d=s100-c-k-c0x00ffffff-no-rj',
    website: '#'
  }
];

export const PROGRAMS: ProgramItem[] = [
  {
    id: '01',
    title: 'USAID - CEGAH',
    client: 'USAID-MSI-CEGAH',
    description: 'Strengthening Civil Servants Against Radicalism, Pesantren Antikorupsi & Monitoring Delivery of Social Safety Net Program',
  },
  {
    id: '02',
    title: 'Ministry of Finance and National Achieve of Indonesia',
    client: 'Ministry of Finance and National Achieve of Indonesia',
    description: 'The implementation of Tolerance, Pluralism Awareness/Attitude Test (TuPAT) instrument in the process of civil servants recruitment',
  },
  {
    id: '03',
    title: 'DFAT - Australia',
    client: 'DFAT - The Asian Foundation',
    description: 'Mainstreaming Social Inclusion through Discriminating-Free Public Services & Inclusion Program: Creating Joint Solutions Multi-stakeholder (Co-Creation) for Inclusive Services in Preventing Child Marriage',
  },
  {
    id: '04',
    title: 'BTPN Syariah',
    client: 'BTPN Syariah',
    description: 'Improving Community Participation in Village Development (TEPAT PEDULI)',
  },
  {
    id: '05',
    title: 'Kemenham',
    client: 'Kementerian HAM Indonesia',
    description: 'Sosialisai HAM',
  },
  {
    id: '06',
    title: 'The World Bank - Kemendesa RI',
    client: 'The World Bank - Kemendesa RI',
    description: 'Institutional Strengthening for Improved Village Service Delivery Project (P3PD)',
  },
  {
    id: '07',
    title: 'Ministry of Religious Affairs, Republic of Indonesia',
    client: 'Ministry of Religious Affairs, Republic of Indonesia',
    description: 'Religious Moderation, Pesantren Empowerment, Religious Indeks Survey, and Tolerance Campaigns',
  },
  {
    id: '08',
    title: 'Ministry of Communication and Information Technology of the Republic of Indonesia',
    client: 'Ministry of Communication and Information Technology of the Republic of Indonesia (KONINFO)',
    description: 'Socialization of Digital Literacy',
  },
  {
    id: '09',
    title: 'ASHOKA INDONESIA',
    client: 'ASHOKA INDONESIA',
    description: 'Building a change Maker of Young Generation for the Benefit of the Community',
  },
  {
    id: '10',
    title: 'GIZ - GERMAN',
    client: 'GIZ - GERMAN',
    description: 'Creating the Community Based-Indonesian Migrant Workers Protection',
  },
  {
    id: '11',
    title: 'Konsorsium Kamela',
    client: 'Konsorsium Kamela',
    description: 'Peningkatan Pendapatan Rumah Tangga Miskin melalui Praktek Usaha Hijau yang Didukung oleh Energi Terbarukan',
  }
];
